import { AddressAutocompleteResult } from '@app/infrastructure/address/model/AddressAutocompleteResult';
import { UrlBuilder } from '@app/lib/http/client/url/UrlBuilder';
import { useCallback, useState } from 'react';

export interface UseAddressAutocompleteOptions {
    filter?: boolean;
}

export interface UseAddressAutocompleteReturnType {
    search: (query: string, country?: string, options?: UseAddressAutocompleteOptions) => Promise<void>;
    results: AddressAutocompleteResult[];
}

export function useAddressAutocomplete(): UseAddressAutocompleteReturnType {
    const [results, setResults] = useState<AddressAutocompleteResult[]>([]);

    const search = useCallback(async (query: string, country?: string, options?: UseAddressAutocompleteOptions) => {
        try {
            const response = await fetch(
                UrlBuilder.build('/api/address/autocomplete', null, null, {
                    q: query,
                    country: country?.toUpperCase(),
                    ...(options?.filter === false ? { filter: 'false' } : {}),
                }),
            );

            if (!response.ok) {
                return setResults([]);
            }

            const result = await response.json();

            setResults(result);
        } catch {
            setResults([]);
        }
    }, []);

    return {
        search,
        results,
    };
}
